import type { StateCreator } from "zustand";
import type { LiveKitRoomSlice } from "../../interfaces/slicesInterfaces/liveKitRoomSlice";

export const createLiveKitRoomSlice: StateCreator<
LiveKitRoomSlice,
  [],
  [],
  LiveKitRoomSlice
> = (set) => ({
  isLiveKitRoomConnected: false,
  
  setIsLiveKitRoomConnected: (connected: boolean) => {
    console.log('LiveKitRoom connection status:', connected);
    set({ isLiveKitRoomConnected: connected });
  },
});

